import { Injectable, computed, signal } from '@angular/core';

export type SocialPlatform = 'facebook' | 'x' | 'linkedin' | 'instagram' | 'youtube' | 'whatsapp' | 'tiktok';

export interface SocialLinks {
  facebook?: string;
  x?: string;
  linkedin?: string;
  instagram?: string;
  youtube?: string;
  whatsapp?: string;
  tiktok?: string;
}

export interface VisibleSocialLink {
  key: SocialPlatform;
  url: string;
  label: string;
}

const LABELS: Record<SocialPlatform, string> = {
  facebook: 'Facebook',
  x: 'X',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  youtube: 'YouTube',
  whatsapp: 'WhatsApp',
  tiktok: 'TikTok',
};

/**
 * Public social links, served from app-config so every surface shows the
 * same values an admin last saved. Only platforms with a configured URL
 * are rendered.
 */
@Injectable({ providedIn: 'root' })
export class PlatformSocialService {
  private readonly links = signal<SocialLinks>({});

  readonly visible = computed<VisibleSocialLink[]>(() =>
    (Object.keys(LABELS) as SocialPlatform[])
      .map((key) => ({ key, url: this.links()[key], label: LABELS[key] }))
      .filter((link): link is VisibleSocialLink => !!link.url)
  );

  apply(links?: SocialLinks | null): void {
    if (!links) {
      return;
    }
    this.links.set(links);
  }
}
